import React from 'react'
import loaderImageGif from '../../../assets/images/loader.gif'


const Index = () => (
    <div id="loading">
        <div id="loading-center">
            <img src={loaderImageGif} alt="loader" />
        </div>
    </div>
);

export default Index;
